import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.login');
import { OnInit, OnDestroy } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-login',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.login/view.scss */
:host {
  display: block;
  color: #202c47;
}

.login-page {
  min-height: 100vh;
  min-height: 100svh;
  padding: 88px 32px 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: #f3f6fb;
}

.login-card {
  display: grid;
  grid-template-columns: 1fr 1fr;
  width: 100%;
  max-width: 1160px;
  overflow: hidden;
  border-radius: 32px;
  background: #fff;
  box-shadow: 0 24px 80px -32px rgba(35, 55, 103, 0.23), 0 2px 8px rgba(35, 55, 103, 0.03);
}

.login-panel {
  padding: 38px 64px 22px;
}

.brand-link {
  display: flex;
  width: fit-content;
  margin: 0 auto;
  align-items: center;
  justify-content: center;
  text-decoration: none;
}

.brand-link img {
  width: 112px;
  height: auto;
}

.login-heading {
  margin: 28px 0 22px;
}

h1 {
  margin: 0 0 10px;
  color: #192642;
  font-size: 32px;
  font-weight: 750;
  letter-spacing: -1.2px;
  line-height: 1.2;
}

.login-form {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.field-group label {
  display: block;
  margin-bottom: 8px;
  color: #34415a;
  font-size: 13px;
  font-weight: 650;
}

.input-wrap {
  position: relative;
}

.field-icon {
  position: absolute;
  left: 19px;
  top: 19px;
  color: #8a98ae;
  font-size: 14px;
  pointer-events: none;
}

.input-wrap input, .input-wrap select {
  width: 100%;
  height: 52px;
  padding: 0 48px;
  border: 1px solid #e9edf4;
  border-radius: 14px;
  outline: none;
  background: #f5f7fb;
  color: #24324f;
  font: inherit;
  font-size: 14px;
  transition: border-color 0.18s, box-shadow 0.18s, background 0.18s;
}
.input-wrap input:focus, .input-wrap select:focus {
  background: #fff;
  border-color: #387dc1;
  box-shadow: 0 0 0 3px rgba(56, 125, 193, 0.12);
}
.input-wrap input::placeholder, .input-wrap select::placeholder {
  color: #8994a8;
  opacity: 1;
}

.input-wrap select {
  appearance: none;
  cursor: pointer;
}

.input-wrap select.is-placeholder {
  color: #8994a8;
}

.input-wrap option {
  color: #24324f;
  background: #fff;
}

.select-chevron {
  position: absolute;
  top: 21px;
  right: 20px;
  font-size: 11px;
  color: #8793a8;
  pointer-events: none;
}

.admin-login-lock {
  position: absolute;
  z-index: 1;
  top: 4px;
  left: 4px;
  display: grid;
  place-items: center;
  width: 44px;
  height: 44px;
  padding: 0;
  border: 0;
  border-radius: 10px;
  background: transparent;
  color: #8a98ae;
  font-size: 14px;
  line-height: 1;
  cursor: default;
}

.password-toggle {
  position: absolute;
  top: 4px;
  right: 7px;
  width: 44px;
  height: 44px;
  border: 0;
  border-radius: 10px;
  background: transparent;
  color: #7b88a1;
  cursor: pointer;
}

.password-toggle:hover {
  color: #235aa2;
  background: #e9eef7;
}

.field-hint {
  margin: 8px 0 0;
  color: #77839a;
  font-size: 11px;
  line-height: 1.6;
}

.login-submit {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  width: 100%;
  min-height: 54px;
  margin-top: 4px;
  border: 0;
  border-radius: 28px;
  background: linear-gradient(105deg, #137db9, #303783 95%);
  color: #fff;
  font-size: 15px;
  font-weight: 700;
  cursor: pointer;
  box-shadow: 0 7px 16px rgba(40, 75, 148, 0.16);
  transition: box-shadow 0.18s, filter 0.18s;
}
.login-submit i {
  position: absolute;
  right: 23px;
  font-size: 13px;
  opacity: 0.8;
}
.login-submit:hover {
  filter: brightness(1.1);
  box-shadow: 0 9px 20px rgba(40, 75, 148, 0.23);
}
.login-submit:disabled {
  cursor: wait;
  opacity: 0.6;
}

a:focus-visible, button:focus-visible {
  outline: 2px solid #2585c0;
  outline-offset: 4px;
}

.recovery-links {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  gap: 6px;
  margin-top: 15px;
  font-size: 11px;
  line-height: 1.8;
}

.recovery-links a {
  color: #6c7991;
  text-decoration: none;
}

.recovery-links span {
  color: #b7c0cf;
}

.recovery-links a:hover {
  color: #265e9d;
  text-decoration: underline;
}

.signup-row {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 9px;
  margin-top: 18px;
  padding-top: 18px;
  border-top: 1px solid #edf0f6;
  font-size: 13px;
  color: #7b879b;
}

.signup-row a {
  color: #2565a2;
  font-weight: 700;
  text-decoration: none;
}

.signup-row a:hover {
  text-decoration: underline;
}

.brand-panel {
  position: relative;
  isolation: isolate;
  display: flex;
  flex-direction: column;
  justify-content: center;
  overflow: hidden;
  padding: 66px 48px 40px;
  background: linear-gradient(145deg, #137db5 0%, #2559a4 42%, #34347f 100%);
  color: #fff;
}
.brand-panel::before, .brand-panel::after {
  content: "";
  position: absolute;
  z-index: -1;
  border: 1px solid rgba(194, 227, 255, 0.1);
  border-radius: 50%;
  pointer-events: none;
}
.brand-panel::before {
  width: 630px;
  height: 630px;
  top: -410px;
  right: -275px;
  box-shadow: 0 0 0 70px rgba(194, 227, 255, 0.025), 0 0 0 140px rgba(194, 227, 255, 0.025);
}
.brand-panel::after {
  width: 520px;
  height: 520px;
  bottom: -400px;
  left: -265px;
  box-shadow: 0 0 0 65px rgba(194, 227, 255, 0.025);
}

.brand-grid {
  position: absolute;
  inset: 0;
  z-index: -1;
  opacity: 0.14;
  background-image: radial-gradient(#b7d5f6 0.7px, transparent 0.7px);
  background-size: 23px 23px;
  mask-image: linear-gradient(transparent, #000 50%, transparent);
}

.brand-content {
  padding: 0 2px;
}

.brand-eyebrow {
  margin: 0 0 27px;
  color: #b9dcf4;
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 2.2px;
}

h2 {
  margin: 0;
  color: #fff;
  font-size: clamp(28px, 3vw, 42px);
  line-height: 1.38;
  font-weight: 650;
  letter-spacing: -1.5px;
}

h2 span {
  display: block;
}

.brand-description {
  margin: 23px 0 0;
  color: #d3e5fa;
  font-size: 14px;
  line-height: 1.9;
  word-break: keep-all;
}

.science-graphic {
  margin: 20px -24px 0;
}

.science-graphic svg {
  display: block;
  width: 100%;
  height: auto;
}

.page-footer {
  margin-top: 23px;
  color: #8b96aa;
  text-align: center;
  font-size: 10px;
  letter-spacing: 0.5px;
}

@media (min-width: 1600px) {
  .login-card {
    max-width: 1240px;
  }
  .login-panel {
    padding: 54px 76px 38px;
  }
  .brand-panel {
    padding-left: 58px;
    padding-right: 58px;
  }
}
@media (max-width: 1050px) {
  .login-panel {
    padding: 38px 36px 26px;
  }
  .brand-panel {
    padding: 48px 32px 34px;
  }
}
@media (max-width: 760px), (max-width: 960px) and (orientation: landscape) and (hover: none) and (pointer: coarse) {
  :host {
    position: relative;
  }
  wiz-component-auth-language {
    position: absolute;
    top: max(12px, env(safe-area-inset-top));
    right: max(16px, env(safe-area-inset-right));
  }
  .login-page {
    justify-content: flex-start;
    padding: max(76px, env(safe-area-inset-top) + 64px) max(12px, env(safe-area-inset-right)) max(16px, env(safe-area-inset-bottom)) max(12px, env(safe-area-inset-left));
  }
  .login-card {
    max-width: 440px;
    grid-template-columns: 1fr;
    border-radius: 20px;
  }
  .login-panel {
    padding: 22px 20px 16px;
  }
  .brand-link img {
    width: 92px;
  }
  .login-heading {
    margin: 18px 0 16px;
  }
  h1 {
    font-size: 28px;
  }
  .login-form {
    gap: 12px;
  }
  .field-group label {
    margin-bottom: 6px;
  }
  .field-icon {
    left: 15px;
  }
  .admin-login-lock {
    left: 0;
  }
  .input-wrap input {
    padding-left: 42px;
    padding-right: 14px;
    font-size: 16px;
  }
  .input-wrap input#password {
    padding-right: 52px;
  }
  .field-hint {
    font-size: 12px;
    color: #65728a;
  }
  .login-submit {
    font-size: 16px;
  }
  .recovery-links {
    display: grid;
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
    gap: 8px;
    margin-top: 14px;
    font-size: 13px;
    line-height: 1.4;
  }
  .recovery-links span {
    display: none;
  }
  .recovery-links a {
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 44px;
    padding: 8px 6px;
    border: 1px solid #e5eaf2;
    border-radius: 10px;
    background: #f8fafd;
    color: #4b607e;
    text-align: center;
  }
  .recovery-links a:last-child {
    grid-column: 1/-1;
  }
  .recovery-links a:hover, .recovery-links a:active {
    background: #edf3fb;
    color: #265e9d;
  }
  .signup-row {
    align-items: center;
    margin-top: 12px;
    padding-top: 8px;
    gap: 4px 9px;
  }
  .signup-row a {
    display: inline-flex;
    align-items: center;
    min-height: 44px;
    padding: 0 4px;
  }
  .brand-panel {
    display: none;
  }
  .page-footer {
    margin-top: 16px;
    font-size: 11px;
  }
}
@media (prefers-reduced-motion: reduce) {
  .input-wrap input, .input-wrap select, .login-submit {
    transition: none;
  }
}`],
})
export class PageLoginComponent implements OnInit, OnDestroy {
    constructor(@Inject( Service) public service: Service) { }

    public initiate = null;
    public sp_key = null;
    public RelayState = null;
    public token = null;

    public mobileLogin = false;
    private mobileQuery: MediaQueryList;
    private updateMobileLayout = () => {
        this.mobileLogin = this.mobileQuery.matches;
        this.service.render();
    };

    public ngOnDestroy() {
        this.mobileQuery?.removeEventListener('change', this.updateMobileLayout);
    }

    public async ngOnInit() {
        this.mobileQuery = window.matchMedia('(max-width: 760px), (max-width: 960px) and (orientation: landscape) and (hover: none) and (pointer: coarse)');
        this.mobileLogin = this.mobileQuery.matches;
        this.mobileQuery.addEventListener('change', this.updateMobileLayout);
        await this.service.init();
        // saml
        const params = new URLSearchParams(document.location.search);
        this.sp_key = params.get("sp_key");
        this.RelayState = params.get("RelayState");

        // oidc
        this.token = params.get("token");

        if (this.sp_key) this.initiate = "saml";
        else if (this.token) this.initiate = "oidc";

        if (this.service.auth.session.id) {
            if (this.initiate === "saml") return this.samlResponse();
            else if (this.initiate === "oidc") return this.oidcResponse();
        }
        await this.service.auth.allow(false, "/landing");
    }

    public view: string = 'login';

    public showPassword = false;
    public busy = false;

    private async requestLogin(action: string, data: any) {
        this.busy = true;
        this.service.loading.show();
        try {
            const response = await wiz.call(action, data, { timeout: 45000 });
            if (!response || typeof response.code !== 'number') throw new Error('INVALID_LOGIN_RESPONSE');
            return response;
        } catch (error) {
            return { code: 503, data: '로그인 서비스에 연결하지 못했습니다. 잠시 후 다시 시도해주세요.' };
        } finally {
            this.busy = false;
            this.service.loading.hide();
        }
    }

    public data: any = {
        account_name: '',
        email: '',
        password: '',
        otp: ''
    };

    public async alert(message: string, status: string = 'error', cancel: any = false, action: string = '확인') {
        return await this.service.alert.show({
            title: "",
            message: message,
            cancel: cancel,
            actionBtn: status,
            action: action,
            status: status
        });
    }

    public samlResponse() {
        const params = new URLSearchParams({
            sp_key: this.sp_key,
            RelayState: this.RelayState,
        });
        return location.href = `/saml/idp/sso/response?${params.toString()}`;
    }

    public oidcResponse() {
        const params = new URLSearchParams({
            token: this.token,
        });
        return location.href = `/oidc/op/verify/user?${params.toString()}`;
    }

    public async admin_login() {
        if (this.busy) return;
        let user = JSON.parse(JSON.stringify(this.data));
        delete user.otp;
        if (!user.password)
            delete user.password;
        else
            user.password = this.service.auth.hash(user.password);

        let { code, data } = await this.requestLogin("admin_login", user);

        if (code == 200) {
            // location.href = "/dashboard";
            sessionStorage.setItem('role', data);
            if (this.initiate === "saml") {
                return this.samlResponse();
            }
            else if (this.initiate === "oidc") {
                return this.oidcResponse();
            }
            else { // local login
                if (data == 'admin') location.href = '/admin/community';
                else location.href = '/dashboard';  // 대시보드로 이동
            }
        } else if (code == 201) {
            this.view = "login";
            await this.service.render();
            setTimeout(() => {
                document.querySelector("input[type=password]").focus();
            }, 150);
        } else if (code == 301) {
            let isjoin = await this.alert(data, 'success', '닫기', '계정 만들기');
            if (!isjoin) return;
            this.view = "join.terms";
            await this.service.render();
        } else {
            await this.alert(data, 'error');
        }
    }

    public async loginkeycloak() {
        // Keycloak 로그인 호출
        const { code, data } = await wiz.call("loginkeycloak");
        if (code === 200) {
            // Keycloak 로그인 URL로 리다이렉트
            window.location.href = data;
        } else {
            await this.service.alert.error("로그인에 실패했습니다.");
        }
    }

    public async loginplaybook() {
        // 입력값 검증
        if (!this.data.account_name || !this.data.password) {
            // this.service.alert.show({
            //     title: "입력 오류",
            //     message: "ID와 Password는 필수 입력 항목입니다.",
            //     actionBtn: "확인",
            //     status: "success"
            // });
            this.alert("ID와 Password는 필수 입력 값입니다.", "success")
            return;  // 입력값이 없으면 로그인 절차를 중단
        }

        this.service.loading.show();

        let user = JSON.parse(JSON.stringify(this.data));
        let { code, data } = await wiz.call("loginplaybook", user);

        this.service.loading.hide();

        // if (code == 200) {
        //     if (data.status === 'pending') {
        //         await this.alert('회원가입 승인 요청 중입니다.', 'error');
        //     } else if (data.password_verified === 'N') {
        //         location.href = '/reset/password';  // 비밀번호 재설정 페이지로 이동
        //     } else if (data.password_verified === 'Y' && data.otp_issuance === 'N') {
        //         location.href = '/otp/issuance';  // OTP 발급 페이지로 이동
        //     } else {
        //         location.href = '/dashboard';  // 대시보드로 이동
        //     }
        // } else {
        //     await this.alert(data, 'error');
        // }
    }

    public async login() {
        if (this.busy || this.service.loading.isshow) return;
        // 입력값 검증
        if (!this.data.account_name || !this.data.password) {
            this.alert("ID와 Password는 필수 입력 값입니다.", "success")
            return;
        }

        if (this.data.otp && !/^[0-9]{6}$/.test(this.data.otp)) {
            await this.alert("OTP 인증번호는 숫자 6자리로 입력해주세요.");
            return;
        }

        this.service.loading.show();

        let user = JSON.parse(JSON.stringify(this.data));
        let { code, data } = await this.requestLogin("login", user);

        this.service.loading.hide();
        await this.service.render();

        if (code == 200) {
            if (!data || typeof data !== 'object') {
                await this.alert('로그인 결과를 확인하지 못했습니다. 다시 시도해주세요.');
                return;
            }
            if (data.first_login) {
                location.href = '/first/login';
            } else if (data.status === 'pending') {
                await this.alert('회원가입 승인 요청 중입니다.', 'error');
            } else if (data.password_verified === 'N') {
                location.href = '/reset/password';  // 비밀번호 재설정 페이지로 이동
            } else if (data.password_verified === 'Y' && data.otp_issuance === 'N') {
                location.href = '/otp/issuance';  // OTP 발급 페이지로 이동
            } else {
                sessionStorage.setItem('role', data.role);
                if (this.initiate === "saml") {
                    return this.samlResponse();
                }
                else if (this.initiate === "oidc") {
                    return this.oidcResponse();
                }
                if (data.role == 'admin') location.href = '/admin/community';
                else location.href = '/dashboard';  // 대시보드로 이동
            }
        } else {
            await this.alert(data, 'error');
        }
    }
}

export default PageLoginComponent;